import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询航交所运价批次配置
export function getAviationExchangePriceByOffice(params) {
  return request({
    url: URL.sys.getAviationExchangePriceByOffice,
    method: 'get',
    params
  })
}

// 保存航交所运价批次配置
export function saveAviationExchangePrice(data) {
  return request({
    url: URL.sys.saveAviationExchangePrice,
    method: 'post',
    data
  })
}

// 获取航交所运价申报范围配置
export function getDeclarationByAviationExchangePrice(params) {
  return request({
    url: URL.sys.getDeclarationByAviationExchangePrice,
    method: 'get',
    params
  })
}

// 获取航交所运价告警与通知
export function getAlarmByAviationExchangePrice(params) {
  return request({
    url: URL.sys.getAlarmByAviationExchangePrice,
    method: 'get',
    params
  })
}

// 获取航交所运价RPA设置
export function getRpaSettingByAviationExchangePrice(params) {
  return request({
    url: URL.sys.getRpaSettingByAviationExchangePrice,
    method: 'get',
    params
  })
}

// 匹配航交所运价批次配置
export function matchOpenPriceConfig(data, branchId) {
  return request({
    url: URL.sys.matchOpenPriceConfig,
    method: 'post',
    data,
    params: { branchId }
  })
}

// 查询航交所运价批次预警列表
export function queryAviationExchangePriceWarning(data) {
  return request({
    url: URL.sys.queryAviationExchangePriceWarning,
    method: 'post',
    data
  })
}

// 执行航交所运价批次预警
export function executeOpenPriceWarning(data, branchId) {
  return request({
    url: URL.sys.executeOpenPriceWarning,
    method: 'post',
    data,
    params: { branchId }
  })
}

// 处理预警
export function processOpenPriceWarning(requestBody) {
  return request({
    url: URL.sys.processOpenPriceWarning,
    method: 'post',
    data: requestBody
  })
}

// 执行航交所运价批次预警
export function getWarningDeclareParams(data, branchId) {
  return request({
    url: URL.sys.getWarningDeclareParams,
    method: 'post',
    data,
    params: { branchId }
  })
}
